export default __webpack_public_path__ + "static/media/bitfinex.9e7da4b3.svg";